export enum MaxValues {
  DEFAULT = 5
}

export interface IUserControlledFieldProps {
  onSave: (value: any) => void
  initialValues: any
  maxValues: number
  disabled?: boolean
}
